export default __webpack_public_path__ + "files/1_1_2_1_Policy_incentives_and_public_initiatives_checklist_for_bioeconomy_development.docx";